import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Card, Input } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { translate } from '../../../../utils/util';
import ModalUpload from './ModalUpload';

const UnloadLocationInsert = (props) => {
    const update = props.location?.state?.update;
    const [openModal, setOpenModal] = useState(false);
    const [unloadlocation, setUnloadLocation] = useState(props.location?.state?.update && props.unloadLocation ? props.unloadLocation : {});

    const onChange = (event) => {
        onValueChange(event, unloadlocation, setUnloadLocation);
    };

    const onConfirm = () => {
        console.log(props.user);
        if (validateInputsRequired()) {
            if (update) {
                props.updateunloadlocation(unloadlocation, (response) => {
                    if (response) {
                        props.history.go(-1);
                    }
                });
            }
            else {
                props.insertunloadlocation(unloadlocation, (response) => {
                    if (response) {
                        props.history.go(-1);
                    }
                });
            }
        }
    };

    return (
        <div>
            <Breadcrumbs id="unloadLocationInsert" title={{ icon: "mdi mdi-view-dashboard-outline", label: "Cadastro de Ponto de Descarga" }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <Card>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding outlined col s12">
                                <Input
                                    required
                                    disabled={update}
                                    maxLength="6"
                                    label="Código"
                                    id="code"
                                    name="code"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={unloadlocation?.code} />
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding outlined col s12">
                                <Input
                                    required
                                    maxLength="20"
                                    label="Descrição"
                                    id="description"
                                    name="description"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={unloadlocation?.description} />
                            </div>
                        </div>
                        <div className="row" style={{ marginBottom: '0px' }}>
                            <div className="input-field no-padding outlined col s12">
                                <Input
                                    required
                                    maxLength={3}
                                    label="Doca"
                                    id="dock"
                                    name="dock"
                                    type="text"
                                    onChange={onChange}
                                    defaultValue={unloadlocation?.dock} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="input-field no-padding  col s1">
                                <button
                                    className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                    type="button"
                                    onClick={() => setOpenModal(true)}>
                                    <i className="Small material-icons">cloud_upload</i>
                                </button>
                            </div>
                        </div>
                        <label>{props.user.visions.filter((i) => i.code === props.user.vision)?.name}</label>
                        <div className="row">
                            <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                            <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                        </div>
                    </Card>
                </div>
            </div>
            <ModalUpload
                open={openModal}
                id="ModalUploadUnloadLocation"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        unloadLocation: state.containerReducer.unloadLocation,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insertunloadlocation: (unloadlocation, callback) => {
            dispatch(ContainerService.insertUnloadLocation(unloadlocation, callback));
        },
        updateunloadlocation: (unloadlocation, callback) => {
            dispatch(ContainerService.updateUnloadLocation(unloadlocation, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UnloadLocationInsert)));
